import { type FunctionComponent } from 'react';
import { type ImageFieldsFragment } from '../../../__generated__/graphql-client-types';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';

export type CategoryBrandLogoProps = {
	image?: ImageFieldsFragment;
};

export const CategoryBrandLogo: FunctionComponent<CategoryBrandLogoProps> = ({ image }) => {
	const { id, description } = image || {};
	return (
		<div className="tc">
			<CloudinaryImage publicID={id || ''} description={description || ''} options={{ width: 0, height: 0 }} />
		</div>
	);
};
